package com.vidaensupalabra.vsp.ventanas

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Img

@Composable
fun YouTubeThumbnail(videoId: String) {
    Img(
        src = "https://img.youtube.com/vi/$videoId/hqdefault.jpg",
        alt = "Miniatura del video",
        attrs = {
            style {
                width(100.percent)
                height(100.percent)
                property("object-fit", "cover")
            }
        }
    )
}